import {
  UserFormDataType,
  UserRoleFormDataType,
  UserViewPermissionFormDataType,
} from './formData/types';

export const defaultUserFormData: UserFormDataType = {
  id: 0,
  validPeriod: [null, null],
  viewPermissions: [],
  roles: [],
  username: '',
  firstName: '',
  lastName: '',
  nationalIdNumber: '',
  createdAt: null,
  createdBy: null,
  modifiedAt: null,
  modifiedBy: null,
  isSuperadmin: false,
  isAdmin: false,
};

export const defaultUserViewPermissionFormData: UserViewPermissionFormDataType =
  {
    id: '' as any,
    validPeriod: [null, null],
  };

export const defaultUserRoleFormData: UserRoleFormDataType = {
  id: '' as any,
  name: '',
  validPeriod: [null, null],
  permissions: [],
  accessGroups: [],
};
